import React from 'react';
import SEO from '../seo/SEO';

function About() {
  const seoData = {
    title: "About Intellectual Oasis Fellowship - Our Mission and Vision",
    description: "Intellectual Oasis Fellowship is a non-profit educational research organization in Lagos, Nigeria, offering fellowship programs, research initiatives, and innovative edtech solutions.",
    keywords: "about Intellectual Oasis Fellowship, education research, fellowship program, educational technology, non-profit organization, Lagos Nigeria",
    image: "/images/about-og.jpg"
  };

  return (
    <>
      <SEO {...seoData} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">About Intellectual Oasis Fellowship</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A non-profit educational research organization based in Lagos, Nigeria, dedicated to transforming education through research, technology, and fellowship programs.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
            <p className="text-gray-600">
              To advance education through research, provide fellowship opportunities for education students, and develop innovative educational technology solutions that enhance learning outcomes.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold mb-4">Our Vision</h2>
            <p className="text-gray-600">
              To be a leading force in educational research and innovation in Nigeria, creating opportunities for students and educators while developing sustainable solutions for educational challenges.
            </p>
          </div>
        </div>

        {/* Core Initiatives */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Our Core Initiatives</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-3">Fellowship Program</h3>
              <p className="text-gray-600">
                Supporting education students in tertiary institutions through mentorship, financial assistance, and professional development opportunities.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-3">Research Organization</h3>
              <p className="text-gray-600">
                Conducting cutting-edge research in education, technology, and learning methodologies to inform policy and practice.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-3">EdTech Platform</h3>
              <p className="text-gray-600">
                Developing innovative educational technology solutions, including course and quiz generation platforms, to enhance learning experiences.
              </p>
            </div>
          </div>
        </div>

        {/* Impact */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Our Impact</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-4xl font-bold text-[rgb(130,88,18)] mb-2">300+</div>
              <p className="text-gray-600">Fellowship Recipients</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-4xl font-bold text-[rgb(130,88,18)] mb-2">50+</div>
              <p className="text-gray-600">Research Projects</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-4xl font-bold text-[rgb(130,88,18)] mb-2">10K+</div>
              <p className="text-gray-600">Platform Users</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-4xl font-bold text-[rgb(130,88,18)] mb-2">15+</div>
              <p className="text-gray-600">Research Publications</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-[rgb(130,88,18)] text-white p-8 rounded-lg">
          <h2 className="text-2xl font-bold mb-4">Join Our Mission</h2>
          <p className="mb-6 max-w-2xl mx-auto">
            Whether you're a student, researcher, educator, or supporter, there are many ways to get involved with Intellectual Oasis Fellowship and help transform education in Nigeria.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/research" className="bg-white text-[rgb(130,88,18)] px-6 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors duration-300">
              Explore Research
            </a>
            <a href="/scholarships" className="bg-white text-[rgb(130,88,18)] px-6 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors duration-300">
              Apply for Fellowship
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default About; 